<template>
  <Tables ref="tableGridPrimeiroAdiantamentaDiverso"
        :columns="['Funcionários Vinculados','Lote','Status','Data de inclusão','Valor do Adiantamento']"
        :showReload="false"
        v-on:Load="Onload"
        :showButtonNew="true"
        :newHeaderStatus="false"
        :showHeader="true"
        >
        <tr v-for="data in ArrayPrimeiroAdiantamento" :key="data.id">
            <TableColumn :IsText="!data.dataDemissao" :IsTextLocked="data.dataDemissao != null ? true : false"   v-on:Edit="onSelect(data.id)" :status="1" :value="data.funcionario == null ? 'N/D' :  data.funcionario" />
            <TableColumn :IsText="!data.dataDemissao" :IsTextLocked="data.dataDemissao != null ? true : false"  v-on:Edit="onSelect(data.id)" :status="1" :value="data.lote == null ? 'N/D' :  data.lote" />
            <TableColumn :IsTextLocked="data.statusDiversos == 5" :class="{'deixar-negrito' : data.statusDiversos == 5}" :IsTextYellow="data.statusDiversos != 4 && data.statusDiversos != 5"   :IsTextGreen="data.statusDiversos == 4"    v-on:Edit="onSelect(data.id)" :status="1" :value="data.primeiroAdiantamento == 1 ? data.statusDespesa == 0 ? 'N/D' : data.statusDespesa : data.statusDespesa" />
            <TableColumn :IsText="!data.dataDemissao" :IsTextLocked="data.dataDemissao != null ? true : false"  v-on:Edit="onSelect(data.id)" :status="1" :value="formataData(data.dataInclusao == null ? 0 : data.dataInclusao)" />
            <TableColumn :IsText="!data.dataDemissao" :IsTextLocked="data.dataDemissao != null ? true : false"   v-on:Edit="onSelect(data.id)" :status="1" :value="formatMoney(data.valor == null ? 0 : data.valor)" />
          </tr>
    </Tables>
</template>

<script>
import AdvanceFirstTrip from './FirstAdvanceMiscellaneous'
export default AdvanceFirstTrip
</script>

<style scoped>
.deixar-negrito {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/FirstAdvanceMiscellaneous/FirstAdvanceMiscellaneous.vue